import { render, staticRenderFns } from "./PolicyCalculation.vue?vue&type=template&id=33c9ce76"
import script from "./PolicyCalculation.vue?vue&type=script&lang=js"
export * from "./PolicyCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports